module.exports = __webpack_public_path__ + "img/docCategoryDownIcon.d6e27d57.svg";